import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});

export async function getComplianceCalenderWithDate() {
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/user-actions`, {

        method: 'GET',
       
      });

      if (!response.ok) {
        throw new Error('Failed to get compliance');
      }

      const result = await response.json();
      //console.log('Compliance fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching compliance:', error);
      throw new Error('Error fetching compliance');
    }
}


export async function getComplianceDashboardCalender() {
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/calendar`, {
        method: 'GET',
      
      });

      if (!response.ok) {
        throw new Error('Failed to get compliance');
      }

      const result = await response.json();
      //console.log('Compliance fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching compliance:', error);
      throw new Error('Error fetching compliance');
    }

}


export async function getComplianceDataFromCalender(startDate:string,endDate:string) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/user-actions?startDate=${startDate}&endDate=${endDate}`, {
      method: 'GET',
      
    });

    if (!response.ok) {
      throw new Error('Failed to get compliance');
    }

    const result = await response.json();
    //console.log('Compliance fetched successfully:', result);
    return result;
  } catch (error) {
    console.error('Error fetching compliance:', error);
    throw new Error('Error fetching compliance');
  }

}